import { Component, OnInit } from '@angular/core';
import { AlertModule } from 'ngx-bootstrap/alert';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BannerData } from 'src/app/interface-model/app-interface-model';
import { BannerService } from 'src/app/services/banner.service';
import { Subscription } from 'rxjs';



@Component({
    selector: 'app-alert-banner',
  standalone: true,
    templateUrl: './alert-banner.component.html',
  styleUrls: ['./alert-banner.component.css'],
  imports: [AlertModule, CommonModule, TranslateModule]
})
export class AlertBannerComponent implements OnInit {
  banner?: BannerData;
  private bannerSubscription?: Subscription;


  constructor(public translateService: TranslateService,private bannerService: BannerService) { }

  ngOnInit() {
    this.bannerSubscription = this.bannerService.banner$.subscribe(banner => {
    this.banner = banner || undefined;
  });
  }

  ngOnDestroy() {
    this.bannerSubscription?.unsubscribe(); // banner stream
  }
}
